import gql from 'graphql-tag'
import client from '@stores/apollo'

export function remove(id: string): Promise<any> {
  return client.gql.mutate({
    mutation,
    variables: { input: { id } },
  })
}

export function batchRemove(ids: string[]): Promise<any> {
  const promises = ids.map((id) => client.gql.mutate({ mutation, variables: { input: { id } } }))

  return Promise.all(promises)
}

const mutation = gql`
  mutation deleteTicket($input: DeleteTicketMutationInput!) {
    deleteTicket(input: $input) {
      ticket {
        id
      }
    }
  }
`
